// เรียก /api/admission/* — ใช้ axiosInstance เสมอ เพราะมันแนบ Bearer token ให้เอง
// และเด้งไปหน้า login เมื่อ token หมดอายุ (ดู services/axiosInterceptor)
import axiosInstance from '../../services/axiosInterceptor'

// ขึ้นต้นด้วย /api/ เพื่อให้ axiosInterceptor เติม REACT_APP_API ให้เอง
const base = '/api/admission'

const unwrap = (p) => p.then((r) => r.data)

export const listApplicants = (params = {}) =>
  unwrap(axiosInstance.get(`${base}/applicants`, { params }))

export const getApplicant = (stId) =>
  unwrap(axiosInstance.get(`${base}/applicant/${stId}`))

export const getApplicantByIdNumber = (idnumber) =>
  unwrap(axiosInstance.get(`${base}/applicant/by-idnumber/${idnumber}`))

export const checkIdCard = (idcard) =>
  unwrap(axiosInstance.get(`${base}/check-idcard/${idcard}`))

export const createApplicant = (payload) =>
  unwrap(axiosInstance.post(`${base}/applicant`, payload))

export const updateApplicant = (stId, payload) =>
  unwrap(axiosInstance.put(`${base}/applicant/${stId}`, payload))

export const fetchSummary = () => unwrap(axiosInstance.get(`${base}/summary`))

export const fetchByProvince = () => unwrap(axiosInstance.get(`${base}/by-province`))

export const fetchReport = (year) =>
  unwrap(axiosInstance.get(`${base}/report`, { params: year ? { year } : {} }))

export const fetchYears = () => unwrap(axiosInstance.get(`${base}/years`))

export const fetchDormitories = () => unwrap(axiosInstance.get(`${base}/dormitories`))
